import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import background from '../../../misc/images/backgrounds/background_03.jpg'
import { IJobsResponse } from '../../../models/Jobs'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import { Breadcrumbs } from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'
import { Jobs } from '../../templates/Jobs'

const JobsPage = () => {
  const i18n = useRecoilValue(translate).jobs
  const breadcrumbs = [
    {
      link: routes.jobs,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<IJobsResponse>(URI.getDataUri('/job', lang))

  return (
    <>
      <ImageSection id={'jobs'} image={background} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data && <Jobs data={data.data} />}
      </PageWrapper>
    </>
  )
}

export default JobsPage
